import React from 'react';
import { Trans } from '@lingui/macro';
import { ValidSections } from '../../../history';

export const VALID_SECTION_LABELS: Record<ValidSections, () => JSX.Element> = {
  [ValidSections.HOME]: () => <Trans>Accueil</Trans>,
  [ValidSections.ONLINE]: () => <Trans>Mon Compte</Trans>,
  [ValidSections.NEWS]: () => <Trans>Actualités</Trans>,
  [ValidSections.BONDS]: () => <Trans>Obligations</Trans>,
  [ValidSections.CONTACT]: () => <Trans>Contact</Trans>,
  [ValidSections.ONBOARDING]: () => <Trans>Devenir client</Trans>,
  [ValidSections.GLOBAL_PLUS_ACCOUNT]: () => <Trans>Compte Global+</Trans>,
  [ValidSections.GOLD_ACCOUNT]: () => <Trans>Compte Gold</Trans>,
  [ValidSections.PREMIUM_ACCOUNT]: () => <Trans>Compte Premium</Trans>,
  [ValidSections.LEGAL]: () => <Trans>Informations légales</Trans>,
  [ValidSections.SECURITY]: () => <Trans>Sécurité</Trans>,
  [ValidSections.SIGN_UP]: () => <Trans>Activer votre accès en ligne</Trans>,
  [ValidSections.UPLOAD]: () => <Trans>Fournir des documents</Trans>,
  [ValidSections.ORDER]: () => <Trans>Passer un ordre</Trans>,
};
